<template>
  <div>
    <div
      v-for="(ack, i) in state"
      :key="ack.transfer_type"
      class="mb-3 pb-3"
      :class="{ 'border-bottom': i !== state.length - 1 }"
    >
      <div class="fw-bold mb-2">{{ ack.label }}</div>
      <div class="form-check form-check-inline">
        <input
          :id="`ack-${i}-informed`"
          v-model="ack.status"
          class="form-check-input"
          type="radio"
          :value="CDR_ACK_STATUS.INFORMED"
          :disabled="readonly"
          @change="$emit('change')"
        />
        <label class="form-check-label" :for="`ack-${i}-informed`">
          {{ trans("admin.cdr.integrationAck.informed") }}
        </label>
      </div>
      <div class="form-check form-check-inline">
        <input
          :id="`ack-${i}-not-informed`"
          v-model="ack.status"
          class="form-check-input"
          type="radio"
          :value="CDR_ACK_STATUS.NOT_INFORMED"
          :disabled="readonly"
          @change="$emit('change')"
        />
        <label class="form-check-label" :for="`ack-${i}-not-informed`">
          {{ trans("admin.cdr.integrationAck.notInformed") }}
        </label>
      </div>
      <textarea
        v-if="ack.status === CDR_ACK_STATUS.NOT_INFORMED"
        v-model="ack.motivation"
        class="form-control mt-2"
        :placeholder="trans('admin.cdr.integrationAck.motivationPlaceholder')"
        :disabled="readonly"
        rows="2"
        @input="$emit('change')"
      />
    </div>
  </div>
</template>

<script>
import { CDR_ACK_STATUS } from "./cdr-constants";

export default {
  props: {
    state: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
  },
  emits: ["change"],
  data() {
    return { CDR_ACK_STATUS };
  },
};
</script>
